import axios from 'axios'

export default {
  checkClient(clientId) {
    // return axios.get('/api/v1/client', {
    //   params: {
    //     'client_id': clientId
    //   }
    // })
    return axios.get('/api/v1/client')
  },
  validateAuth(clientId) {
    return axios.get('/api/v1/client/validate', {
      params: {
        'client_id': clientId
      },
      headers: {
        'Access-Control-Allow-Origin': 'http://localhost:8001',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Headers': '*'
      }
    })
  },
  description(clientId, locale) {
    return axios.get('/api/v1/client/desc', {
      params: {
        'client_id': clientId,
        'locale': locale.toUpperCase()
      },
      headers: {
        'Access-Control-Allow-Origin': 'http://localhost:8001',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Headers': '*'
      }
    })
  }
}
